export const LOGO_URL="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSB69oHMckaDjLADY9_z0SgwiOqF-a3p5vyJg&s";

export const CDN_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/";

//name export

export const MENU_API="https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.705882&lng=77.2785876&restaurantId=";